module.exports = __webpack_public_path__ + "img/the-awakened-kingdom.12ac037a.png";